import { MasterConfigs, Children } from "../../../../interfaces/entity";
export const EmployeeNumberConfig: MasterConfigs = {
    api: () => '/employee-number',
    title: 'Employee Number',
    isActionTab: true,
    modalTitle: (action) => `${action} ${EmployeeNumberConfig.title}`,
    getColumns: () => {
        return [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Prefix',
                dataIndex: 'prefix',
                key: 'prefix',
            },
            {
                title: 'Degits',
                dataIndex: 'degits',
                key: 'degits',
            },
            {
                title: 'Suffix',
                dataIndex: 'suffix',
                key: 'suffix',
            },
            {
                title: 'Next Number',
                dataIndex: 'nextNumber',
                key: 'nextNumber',
            },
            {
                title: 'Created On',
                dataIndex: 'createdAt',
                key: 'createdAt',
                width: 150,
                render: (date) => {
                    return new Date(date).toDateString();
                }
            },
        ];
    },
    getFormColumns: () => {
        return [
            {
                label: 'Serise Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Name is required' }],
            },
            {
                span: 12,
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                inputTextAreaProps: { rows: 1 },
            },
            {
                label: 'Prefix',
                name: 'prefix',
                type: 'text',
            },
            {
                label: 'Degits',
                name: 'degits',
                type: 'select',
                children: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e) => ({ value: e, name: e.toString() })),
            },
            {
                label: 'Suffix',
                name: 'suffix',
                type: 'text',
            },
            {
                label: 'Next Number',
                name: 'nextNumber',
                type: 'number',
            },
            {
                label: 'Number Proview',
                name: 'numberPreview',
                type: 'text',
                inputProps: { disabled: true },
            },
        ];
    },
    combo: [],
    getData: () => ({}),
    actions: [
        { name: 'Add Employee Number', actionType: 'Add' }
    ],
};
